import { translate } from "app/filters/i18nFilter";

import type { LeadScoreFilterOption } from "../models/LeadScoreFilter/const";

import leadsSearchFiltersI18nKeys from "./i18n";

export const getLeadScoreFilterOptionLabel = (score: LeadScoreFilterOption): string =>
    translate(leadsSearchFiltersI18nKeys.leadScoresOption(score));
